// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mt-6";
export var imgContainer = "_mt-3";
export var menuIcon = "_mt-5";
export var pillWrapper = "_mt-2";
export var pillsContainer = "_mt-1";
export var subscriptionCard = "_mt-0";
export var subscriptionLogo = "_mt-4";